import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { CommonService } from '@modules/shared/services/common.service';
import { environment } from 'environments/environment';
import { APIConstant } from '@/constant/APIConstant';
import { Subject } from 'rxjs';
import { log } from 'node:console';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userAccess: Subject<any>;

  constructor(
    private http: HttpClient,
    private router: Router,
    private commonService: CommonService
  ) { }
  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('authToken') || '';
    return new HttpHeaders().set('Authorization', `Bearer ${token}`);
  }
  signIn(params: any) {
    return this.http.post(`${environment.baseUrl + APIConstant.auth.login}`, params);
  }
  signInAdmin(params: any) {
    return this.http.post(`${environment.baseUrlAerolounge + APIConstant.auth.adminLogin}`, params);
  }
  logoutAdmin() {
    return this.http.post(`${environment.baseUrlAerolounge}/app/v1/users/logout`,
      {},
      {
        headers: this.getAuthHeaders()
      }
    );
  }

  signOut() {
    //this.commonService.removeAll();
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_data');
    localStorage.removeItem('user_access');
    localStorage.removeItem('previousPath');

    if (this.userAccess) {
      this.userAccess.unsubscribe();
    }
    this.router.navigate(['/login']);
  }

  sendOTP(params: any) {
    return this.http.post(`${environment.baseUrl + APIConstant.auth.forgotPassword}`, params, { observe: 'response' });
  }

  renewForgetPassword(params: any) {
    return this.http.post(`${environment.baseUrl + APIConstant.auth.setNewPassWord}`, params, { observe: 'response' });
  }

  refreshToken(token: string) {
    return this.http.post(environment.baseUrlAerolounge + APIConstant.auth.refreshToken, {
      refresh_token: token
    });
  }

  refreshTokenAndLogin() {
    const refreshToken = this.commonService.getItem('refresh_token'); // get from localStorage or service

    if (!refreshToken) return;

    this.http.post(environment.baseUrl + APIConstant.auth.refreshToken, {
      refresh_token: refreshToken
    }).subscribe({
      next: (res: any) => {
        if (res?.status_code === 200) {
          const accessToken = res.data.access_token;

          // 1. Store access token
          this.commonService.setItem('access_token', accessToken);

          // 2. Decode and store user data (optional)
          const tokenParts = accessToken.split('.');
          const payload = JSON.parse(atob(tokenParts[1]));
          const email = payload?.email;

          const userData = { email };
          this.commonService.setItem('user_data', userData);

          // 3. Optionally: Notify other parts of the app
          // this.authStateSubject.next(true); // example BehaviorSubject

          // 4. Continue where user left off or redirect
          // this.router.navigate(['/dashboard']);
        }
      },
      error: (err) => {
        console.error('Refresh token failed:', err);
        // this.logout(); // if needed
      }
    });
  }

  getAccessList(params): any {
    return this.http.post(environment.baseUrl + APIConstant.auth.accessPermission, params);
  }

  forgotPassword(email: string): any {
    return this.http.post(`${environment.baseUrlAerolounge}/app/v1/auth/forgot-password`, { email });
  }

  resetPassword(data: { email: string; code: string; new_password: string }) {
    return this.http.post(
      `${environment.baseUrlAerolounge}/app/v1/auth/reset-password`,
      data
    );
  }


}
